import React, { useContext, useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as Constants from '../../Constants';
// import Footer from '../pageComponents/Footer';
import Navigation from '../pageComponents/Navigation';
import Header from '../pageComponents/Header';
import './ImagePage.scss';
import { LanguageContext } from "../language/LanguageContext";
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

function ImagePage() {
    const { dictionary } = useContext(LanguageContext);
    const location = useLocation();
    const [images, setImages] = useState([]);
    const [customClassName, setCustomClassName] = useState('');
    const [loading, setLoading] = useState(false);
    const pswpElement = useRef(null);
    const galleryRef = useRef(null);

    useEffect(() => {
        let newImages;
        switch (location.pathname) {
            

            case Constants.TWO_THOUSAND_TEN_TO_TWO_THOUSAND_TWENTY_FIVE_ROUTE:
                newImages = [


                    
                    

                    
                    { src: '1529_1920.jpg', thumbnail_src: '1529_500.jpg' },
                    { src: '1528_1920.jpg', thumbnail_src: '1528_500.jpg' },                                   
                    { src: '1527_1920.jpg', thumbnail_src: '1527_500.jpg' },                    
                    { src: '1522_1920.jpg', thumbnail_src: '1522_500.jpg' },
                    { src: '1518_1920.jpg', thumbnail_src: '1518_500.jpg' },
                    { src: '1516_1920.jpg', thumbnail_src: '1516_500.jpg' },                 
                    { src: '1514_1920.jpg', thumbnail_src: '1514_500.jpg' },
                    { src: '1513_1920.jpg', thumbnail_src: '1513_500.jpg' },
                    //{ src: '1512_1920.jpg', thumbnail_src: '1512_500.jpg' }, muss noch in Übermalung geändert werden, erst Löschvorgang mit Tobias klären
                    { src: '1511_1920.jpg', thumbnail_src: '1511_500.jpg' },
                    { src: '1510_1920.jpg', thumbnail_src: '1510_500.jpg' },
                    { src: '1509_1920.jpg', thumbnail_src: '1509_500.jpg' },
                    { src: '1504_1920.jpg', thumbnail_src: '1504_500.jpg' },
                    { src: '1503_1920.jpg', thumbnail_src: '1503_500.jpg' },
                    { src: '1501_1920.jpg', thumbnail_src: '1501_500.jpg' },
                    { src: '1500_1920.jpg', thumbnail_src: '1500_500.jpg' },
                    { src: '1499_1920.jpg', thumbnail_src: '1499_500.jpg' },
                    { src: '1494_1920.jpg', thumbnail_src: '1494_500.jpg' },
                    { src: '1476_1920.jpg', thumbnail_src: '1476_500.jpg' },
                    { src: '1475_1920.jpg', thumbnail_src: '1475_500.jpg' },
                    { src: '1474_1920.jpg', thumbnail_src: '1474_500.jpg' },
                    { src: '1492_1920.jpg', thumbnail_src: '1492_500.jpg' },
                    { src: '1491_1920.jpg', thumbnail_src: '1491_500.jpg' },
                    { src: '1478_1920.jpg', thumbnail_src: '1478_500.jpg' },
                    { src: '1446_1920.jpg', thumbnail_src: '1446_500.jpg' },
                    { src: '1445_1920.jpg', thumbnail_src: '1445_500.jpg' },
                    { src: '1444_1920.jpg', thumbnail_src: '1444_500.jpg' },
                    { src: '1443_1920.jpg', thumbnail_src: '1443_500.jpg' },
                    { src: '1440_1920.jpg', thumbnail_src: '1440_500.jpg' },
                    { src: '1439_1920.jpg', thumbnail_src: '1439_500.jpg' },
                    { src: '1433_1920.jpg', thumbnail_src: '1433_500.jpg' },
                    { src: '1432_1920.jpg', thumbnail_src: '1432_500.jpg' },
                    { src: '1431_1920.jpg', thumbnail_src: '1431_500.jpg' },
                    { src: '1429_1920.jpg', thumbnail_src: '1429_500.jpg' },
                    { src: '1427_1920.jpg', thumbnail_src: '1427_500.jpg' },
                    { src: '1426_1920.jpg', thumbnail_src: '1426_500.jpg' },
                    { src: '1425_1920.jpg', thumbnail_src: '1425_500.jpg' },
                    { src: '1424_1920.jpg', thumbnail_src: '1424_500.jpg' },
                    { src: '1423_1920.jpg', thumbnail_src: '1423_500.jpg' },
                    { src: '1420_1920.jpg', thumbnail_src: '1420_500.jpg' },
                    { src: '1407_1920.jpg', thumbnail_src: '1407_500.jpg' },
                    { src: '1406_1920.jpg', thumbnail_src: '1406_500.jpg' },
                    { src: '1405_1920.jpg', thumbnail_src: '1405_500.jpg' },
                    { src: '1404_1920.jpg', thumbnail_src: '1404_500.jpg' },
                    { src: '1403_1920.jpg', thumbnail_src: '1403_500.jpg' },
                    { src: '1402_1920.jpg', thumbnail_src: '1402_500.jpg' },
                    { src: '1401_1920.jpg', thumbnail_src: '1401_500.jpg' },
                    { src: '1400_1920.jpg', thumbnail_src: '1400_500.jpg' },
                    { src: '1399_1920.jpg', thumbnail_src: '1399_500.jpg' },
                    { src: '1396_1920.jpg', thumbnail_src: '1396_500.jpg' },
                    { src: '1395_1920.jpg', thumbnail_src: '1395_500.jpg' },
                    { src: '1392_1920.jpg', thumbnail_src: '1392_500.jpg' },
                    { src: '1388_1920.jpg', thumbnail_src: '1388_500.jpg' },
                    { src: '1381_1920.jpg', thumbnail_src: '1381_500.jpg' },
                    { src: '1376_1920.jpg', thumbnail_src: '1376_500.jpg' },
                    { src: '1375_1920.jpg', thumbnail_src: '1375_500.jpg' },
                    { src: '1370_1920.jpg', thumbnail_src: '1370_500.jpg' },
                    { src: '1369_1920.jpg', thumbnail_src: '1369_500.jpg' },
                    { src: '1368_1920.jpg', thumbnail_src: '1368_500.jpg' },
                    { src: '1364_1920.jpg', thumbnail_src: '1364_500.jpg' },
                    { src: '1356_1920.jpg', thumbnail_src: '1356_500.jpg' },
                    { src: '1345_1920.jpg', thumbnail_src: '1345_500.jpg' },
                    { src: '1336_1920.jpg', thumbnail_src: '1336_500.jpg' },
                    { src: '1331_1920.jpg', thumbnail_src: '1331_500.jpg' },
                    { src: '1320_1920.jpg', thumbnail_src: '1320_500.jpg' },
                    { src: '1319_1920.jpg', thumbnail_src: '1319_500.jpg' },
                    { src: '1310_1920.jpg', thumbnail_src: '1310_500.jpg' },
                    { src: '1309_1920.jpg', thumbnail_src: '1309_500.jpg' },                    
                    { src: '1308_1920.jpg', thumbnail_src: '1308_500.jpg' },
                    { src: '1307_1920.jpg', thumbnail_src: '1307_500.jpg' },
                    { src: '1306_1920.jpg', thumbnail_src: '1306_500.jpg' },                
                    { src: '1305_1920.jpg', thumbnail_src: '1305_500.jpg' },
                    { src: '1304_1920.jpg', thumbnail_src: '1304_500.jpg' },
                    { src: '1264_1920.jpg', thumbnail_src: '1264_500.jpg' },
                    { src: '1241_1920.jpg', thumbnail_src: '1241_500.jpg' },
                    { src: '1230_1920.jpg', thumbnail_src: '1230_500.jpg' },
                    { src: '1203_1920.jpg', thumbnail_src: '1203_500.jpg' },
                    { src: '1202_1920.jpg', thumbnail_src: '1202_500.jpg' },
                    { src: '1201_1920.jpg', thumbnail_src: '1201_500.jpg' },
                    { src: '1200_1920.jpg', thumbnail_src: '1200_500.jpg' },
                    { src: '1199_1920.jpg', thumbnail_src: '1199_500.jpg' },
                    { src: '1159_1920.jpg', thumbnail_src: '1159_500.jpg' },
                    { src: '1145_1920.jpg', thumbnail_src: '1145_500.jpg' },
                    { src: '1144_1920.jpg', thumbnail_src: '1144_500.jpg' },
                    { src: '1143_1920.jpg', thumbnail_src: '1143_500.jpg' },
                    { src: '1140_1920.jpg', thumbnail_src: '1140_500.jpg' },
                    { src: '1134_1920.jpg', thumbnail_src: '1134_500.jpg' },
                    { src: '1129_1920.jpg', thumbnail_src: '1129_500.jpg' },
                    { src: '1114_1920.jpg', thumbnail_src: '1114_500.jpg' },
                    { src: '1108_1920.jpg', thumbnail_src: '1108_500.jpg' },
                    { src: '1107_1920.jpg', thumbnail_src: '1107_500.jpg' },
                    { src: '1106_1920.jpg', thumbnail_src: '1106_500.jpg' },
                    { src: '1079_1920.jpg', thumbnail_src: '1079_500.jpg' },
                    { src: '1068_1920.jpg', thumbnail_src: '1068_500.jpg' },
                    { src: '1058_1920.jpg', thumbnail_src: '1058_500.jpg' },
                    { src: '1037_1920.jpg', thumbnail_src: '1037_500.jpg' },
                    { src: '1017_1920.jpg', thumbnail_src: '1017_500.jpg' },
                    { src: '1016_1920.jpg', thumbnail_src: '1016_500.jpg' },
                    { src: '972_1920.jpg', thumbnail_src: '972_500.jpg' },
                    { src: '931_1920.jpg', thumbnail_src: '931_500.jpg' },
                    { src: '930_1920.jpg', thumbnail_src: '930_500.jpg' },
                    { src: '920_1920.jpg', thumbnail_src: '920_500.jpg' },
                    { src: '908_1920.jpg', thumbnail_src: '908_500.jpg' },
                    { src: '881_1920.jpg', thumbnail_src: '881_500.jpg' },
                    { src: '842_1920.jpg', thumbnail_src: '842_500.jpg' },
                    { src: '830_1920.jpg', thumbnail_src: '830_500.jpg' },
                    { src: '776_1920.jpg', thumbnail_src: '776_500.jpg' },
                    { src: '732_1920.jpg', thumbnail_src: '732_500.jpg' },
                    { src: '717_1920.jpg', thumbnail_src: '717_500.jpg' }

                  ];
                setCustomClassName('malerei');
                break;


                            case Constants.NINETEEN_NINETY_TO_TWO_THOUSAND_NINE_ROUTE:
                newImages = [
                    
                    { src: '650_1920.jpg', thumbnail_src: '650_500.jpg' },
                    { src: '677_1920.jpg', thumbnail_src: '677_500.jpg' },
                    { src: '645_1920.jpg', thumbnail_src: '645_500.jpg' },
                    { src: '518_1920.jpg', thumbnail_src: '518_500.jpg' },
                    { src: '551_1920.jpg', thumbnail_src: '551_500.jpg' },
                    { src: '697_1920.jpg', thumbnail_src: '697_500.jpg' },
                    { src: '150_1920.jpg', thumbnail_src: '150_500.jpg' },
                    { src: '141_1920.jpg', thumbnail_src: '141_500.jpg' },
                    { src: '243_1920.jpg', thumbnail_src: '243_500.jpg' },     
                    { src: '173_1920.jpg', thumbnail_src: '173_500.jpg' },
                    { src: '163_1920.jpg', thumbnail_src: '163_500.jpg' },
                    { src: '247_1920.jpg', thumbnail_src: '247_500.jpg' },
                    { src: '695_1920.jpg', thumbnail_src: '695_500.jpg' }
                        
                        
                    
                ];
                setCustomClassName('malerei');
                break;

case Constants.NINETEEN_EIGHTY_TO_NINETEEN_NINETY_ROUTE:
                newImages = [
                    
                    { src: '96_1920.jpg', thumbnail_src: '96_500.jpg' },
                    { src: '114_1920.jpg', thumbnail_src: '114_500.jpg' },
                    { src: '112_1920.jpg', thumbnail_src: '112_500.jpg' },
                    { src: '92_1920.jpg',  thumbnail_src: '92_500.jpg' },
                    { src: '119_1920.jpg', thumbnail_src: '119_500.jpg' },
                    { src: '124_1920.jpg', thumbnail_src: '124_500.jpg' }
                        
                        
                    
                ];
                setCustomClassName('malerei');
                break;

 
             case Constants.ACRYL_ROUTE:
                newImages = [
                    { src: 'UDSC02639_1920.jpg', thumbnail_src: 'UDSC02639_1920.jpg'},
                    { src: 'UDSC02649_1920.jpg', thumbnail_src: 'UDSC02649_1920.jpg'},
                    { src: 'UDSC02654_1920.jpg', thumbnail_src: 'UDSC02654_1920.jpg'},
                    { src: 'UDSC02683_1920.jpg', thumbnail_src: 'UDSC02683_1920.jpg'},
                    { src: 'UDSC02686_1920.jpg', thumbnail_src: 'UDSC02686_1920.jpg'},
                    { src: 'UDSC02694_1920.jpg', thumbnail_src: 'UDSC02694_1920.jpg'},
                    { src: 'II341_640.jpg', thumbnail_src: 'II341_640.jpg'},
                    { src: 'II340_640.jpg', thumbnail_src: 'II340_640.jpg'},
                    { src: 'II339_640.jpg', thumbnail_src: 'II339_640.jpg'},
                    { src: 'II338_640.jpg', thumbnail_src: 'II338_640.jpg'},
                    { src: 'II335_640.jpg', thumbnail_src: 'II335_640.jpg'},
                    { src: 'II321_640.jpg', thumbnail_src: 'II321_640.jpg'},
                    { src: 'II368_640.jpg', thumbnail_src: 'II368_640.jpg'},
                    { src: 'II359_640.jpg', thumbnail_src: 'II359_640.jpg'},
                    { src: 'II363_640.jpg', thumbnail_src: 'II363_640.jpg'},
                    { src: 'II360_640.jpg', thumbnail_src: 'II360_640.jpg'},
                    { src: 'II361_660.jpg', thumbnail_src: 'II361_660.jpg'},
                    { src: 'II362_660.jpg', thumbnail_src: 'II362_660.jpg'},
                    { src: 'II365_640.jpg', thumbnail_src: 'II365_640.jpg'},
                    { src: 'II364_640.jpg', thumbnail_src: 'II364_640.jpg'},
                    { src: 'II367_640.jpg', thumbnail_src: 'II367_640.jpg'}
                ];
                setCustomClassName('papier');
                break;
      
                case Constants.DRAWING_ROUTE:
                newImages = [
                    { src: '2024_2_51x75_640.jpg', thumbnail_src: '2024_2_51x75_640.jpg'},
                    { src: '2024_3_51x75_640.jpg', thumbnail_src: '2024_3_51x75_640.jpg'},
                    { src: '2024_1_47x75cm_640.jpg', thumbnail_src: '2024_1_47x75cm_640.jpg'},
                    { src: '2024_4_51x75cm_640.jpg', thumbnail_src: '2024_4_51x75cm_640.jpg'},
                    { src: 'IMG9858_640.jpg', thumbnail_src: 'IMG9858_640.jpg'},
                    { src: 'IMG9843_640.jpg', thumbnail_src: 'IMG9843_640.jpg'},
                    { src: 'IMG9656_640.jpg', thumbnail_src: 'IMG9656_640.jpg'},
                    { src: 'IMG9544_640.jpg', thumbnail_src: 'IMG9544_640.jpg'},
                    { src: 'IMG9214_640.jpg', thumbnail_src: 'IMG9214_640.jpg'},
                    { src: 'IMG9796_640.jpg', thumbnail_src: 'IMG9796_640.jpg'}
                ];
                setCustomClassName('papier');
                break;
 
                case Constants.GRAPHIC_ROUTE:
                newImages = [
                    { src: '2023_72x98_640.jpg', thumbnail_src: '2023_72x98_640.jpg'},
                    { src: '2024d_640.jpg', thumbnail_src: '2024d_640.jpg'},
                    { src: '2020_ot_640.jpg', thumbnail_src: '2020_ot_640.jpg'},
                    { src: 'Kreuzigung_640.jpg', thumbnail_src: 'Kreuzigung_640.jpg'},
                    { src: 'DSC02999b_800.jpg', thumbnail_src: 'DSC02999b_800.jpg'},
                    { src: 'Balance_640.jpg', thumbnail_src: 'Balance_640.jpg'},
                    { src: 'IMG_0522_640.jpg', thumbnail_src: 'IMG_0522_640.jpg'},
                    { src: 'IMG_3398_640.jpg', thumbnail_src: 'IMG_3398_640.jpg'},
                    { src: 'Ortung_640.jpg', thumbnail_src: 'Ortung_640.jpg'},
                    { src: 'Erinnerung_640.jpg', thumbnail_src: 'Erinnerung_640.jpg'},
                    { src: 'Ueberflug_640.jpg', thumbnail_src: 'Ueberflug_640.jpg'},
                    { src: 'Bucht_640.jpg', thumbnail_src: 'Bucht_640.jpg'},
                    { src: 'Bucht2_640.jpg', thumbnail_src: 'Bucht2_640.jpg'},
                    { src: 'Fruehlingsflut_640.jpg', thumbnail_src: 'Fruehlingsflut_640.jpg'},
                    { src: 'Insel_640.jpg', thumbnail_src: 'Insel_640.jpg'},
                    { src: 'Thermal_640.jpg', thumbnail_src: 'Thermal_640.jpg'},
                    { src: 'Ufer_am_Morgen_640.jpg', thumbnail_src: 'Ufer_am_Morgen_640.jpg'},
                    { src: 'Erkundung_640.jpg', thumbnail_src: 'Erkundung_640.jpg'}
                ];
                setCustomClassName('papier');
                break;
            case Constants.TRAVEL_ROUTE:
                newImages = [
                    { src: '1083_600.jpg', thumbnail_src: '1083_600.jpg'},
                    { src: '1093_600.jpg', thumbnail_src: '1093_600.jpg'},
                    { src: '1103_600.jpg', thumbnail_src: '1103_600.jpg'},
                    { src: '1104_600.jpg', thumbnail_src: '1104_600.jpg'},
                    { src: '1204_600.jpg', thumbnail_src: '1204_600.jpg'},
                    { src: '1206_600.jpg', thumbnail_src: '1206_600.jpg'},
                    { src: '1207_600.jpg', thumbnail_src: '1207_600.jpg'},
                    { src: '1208_600.jpg', thumbnail_src: '1208_600.jpg'},
                    { src: '1214_600.jpg', thumbnail_src: '1214_600.jpg'},
                    { src: '1215_600.jpg', thumbnail_src: '1215_600.jpg'},
                    { src: '1244_600.jpg', thumbnail_src: '1244_600.jpg'},
                    { src: '1248_600.jpg', thumbnail_src: '1248_600.jpg'},
                    { src: '1250_600.jpg', thumbnail_src: '1250_600.jpg'},
                    { src: '1254_600.jpg', thumbnail_src: '1254_600.jpg'},
                    { src: '1255_600.jpg', thumbnail_src: '1255_600.jpg'},
                    { src: '1256_600.jpg', thumbnail_src: '1256_600.jpg'},
                    { src: '1269_600.jpg', thumbnail_src: '1269_600.jpg'},
                    { src: '1270_600.jpg', thumbnail_src: '1270_600.jpg'},
                    { src: '1273_600.jpg', thumbnail_src: '1273_600.jpg'},
                    { src: '1275_600.jpg', thumbnail_src: '1275_600.jpg'},
                    { src: '1279_600.jpg', thumbnail_src: '1279_600.jpg'},
                    { src: '1280_600.jpg', thumbnail_src: '1280_600.jpg'},
                    { src: '1281_600.jpg', thumbnail_src: '1281_600.jpg'},
                    { src: '1282_600.jpg', thumbnail_src: '1282_600.jpg'},
                    { src: '1284_600.jpg', thumbnail_src: '1284_600.jpg'},
                    { src: '1286_600.jpg', thumbnail_src: '1286_600.jpg'},
                    { src: '1287_600.jpg', thumbnail_src: '1287_600.jpg'},
                    { src: '1288_600.jpg', thumbnail_src: '1288_600.jpg'},
                    { src: '1289_600.jpg', thumbnail_src: '1289_600.jpg'},
                    { src: '1291_600.jpg', thumbnail_src: '1291_600.jpg'},
                    { src: '1292_600.jpg', thumbnail_src: '1292_600.jpg'},
                    { src: '1294_600.jpg', thumbnail_src: '1294_600.jpg'},
                    { src: '1295_600.jpg', thumbnail_src: '1295_600.jpg'},
                    { src: '1408_600.jpg', thumbnail_src: '1408_600.jpg'},
                    { src: '1410_600.jpg', thumbnail_src: '1410_600.jpg'},
                    { src: '1411_600.jpg', thumbnail_src: '1411_600.jpg'},
                    { src: '1412_600.jpg', thumbnail_src: '1412_600.jpg'},                    
                    { src: '1414_600.jpg', thumbnail_src: '1414_600.jpg'},
                    { src: '1415_600.jpg', thumbnail_src: '1415_600.jpg'},                   
                    { src: '1416_600.jpg', thumbnail_src: '1416_600.jpg'},
                    { src: '1419_600.jpg', thumbnail_src: '1419_600.jpg'}
                ];
                setCustomClassName('realstudien');
                break;
            case Constants.PORTRAIT_ROUTE:
                newImages = [
                   { src: '727_550.jpg', thumbnail_src: '727_550.jpg'},
                   { src: '709_450.jpg', thumbnail_src: '709_450.jpg'},
                   { src: '1168_600.jpg', thumbnail_src: '1168_600.jpg'},
                   { src: '772_450.jpg', thumbnail_src: '772_450.jpg'},
                   { src: 'DSC02622_600.jpg', thumbnail_src: 'DSC02622_600.jpg'},
                   { src: '1013_550.jpg', thumbnail_src: '1013_550.jpg'},
                   { src: '1283_600.jpg', thumbnail_src: '1283_600.jpg'},
                   { src: 'IMG_4618_600.jpg', thumbnail_src: 'IMG_4618_600.jpg'},
                   { src: '1216_750.jpg', thumbnail_src: '1216_750.jpg'},
                   { src: '1221_750.jpg', thumbnail_src: '1221_750.jpg'},
                   { src: '1222_750.jpg', thumbnail_src: '1222_750.jpg'},
                   { src: 'Anja2_550.jpg', thumbnail_src: 'Anja2_550.jpg'},
                   { src: 'IMG7959_550.jpg', thumbnail_src: 'IMG7959_550.jpg'},
                   { src: 'Silke2017_550.jpg', thumbnail_src: 'Silke2017_550.jpg'},
                   { src: 'Mutter_550.jpg', thumbnail_src: 'Mutter_550.jpg'},
                   { src: 'VaterSohn_550.jpg', thumbnail_src: 'VaterSohn_550.jpg'},
                   { src: 'Mutter2_550.jpg', thumbnail_src: 'Mutter2_550.jpg'}
                ];
                setCustomClassName('realstudien');
                break;
            default:
                newImages = [];
                break;
        }
        setImages(newImages);
        // Preload images as soon as images are set

        
    }, [location.pathname]);

    // Helper to get image dimensions
    const getImageDimensions = (src) => {
        return new Promise((resolve, reject) => {
            const img = new window.Image();
            img.onload = function() {
                resolve({ w: img.naturalWidth, h: img.naturalHeight });
            };
            img.onerror = function(err) {
                console.error('Failed to load image for PhotoSwipe:', src, err);
                reject(new Error('Failed to load image: ' + src));
            };
            img.src = src;
        });
    };

    const openPhotoSwipe = async (index) => {
        try {
            setLoading(true);
            if (!pswpElement.current) {
                console.error('PhotoSwipe element ref is not ready.');
                setLoading(false);
                return;
            }
            if (!images || images.length === 0) {
                console.error('No images available for PhotoSwipe.');
                setLoading(false);
                return;
            }
            // Destroy previous instance if exists
            if (galleryRef.current) {
                try {
                    galleryRef.current.destroy();
                } catch (err) {
                    // Ignore errors if already destroyed
                }
                galleryRef.current = null;
            }
            // Preload images
            await Promise.all(images.map(image => {
                const src = `${process.env.PUBLIC_URL}/images/${image.src}`;
                return new Promise(resolve => {
                    const img = new window.Image();
                    img.onload = () => resolve();
                    img.onerror = () => resolve();
                    img.src = src;
                });
            }));
            // Get actual dimensions for all images
            const items = await Promise.all(images.map(async (image) => {
                const src = `${process.env.PUBLIC_URL}/images/${image.src}`;
                try {
                    const { w, h } = await getImageDimensions(src);
                    return {
                        src,
                        w,
                        h,
                        title: dictionary.image_texts[image.src] || ''
                    };
                } catch (err) {
                    // Fallback to default size if image fails to load
                    return {
                        src,
                        w: 800,
                        h: 600,
                        title: dictionary.image_texts[image.src] || ''
                    };
                }
            }));
            setLoading(false);
            const options = {
                index,
                bgOpacity: 0.8,
                showHideOpacity: true
            };
            const gallery = new PhotoSwipe(
                pswpElement.current,
                PhotoSwipeUI_Default,
                items,
                options
            );
            galleryRef.current = gallery;
            gallery.init();
        } catch (err) {
            setLoading(false);
            console.error('Error opening PhotoSwipe:', err);
        }
    };

    return (
        <>
            <Header />
            <Navigation />
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <svg width="50" height="50" viewBox="0 0 50 50">
                            <circle cx="25" cy="25" r="20" fill="none" stroke="#888" strokeWidth="5" strokeDasharray="31.4 31.4" strokeLinecap="round">
                                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                            </circle>
                        </svg>
                    </div>
                </div>
            )}
            <div className={`image-holder main${location.pathname ? ' ' + customClassName : ''}`}>
                {images.map((image, index) => (
                    <img
                        key={index}
                        className='thumbnail'
                        src={`${process.env.PUBLIC_URL}/images/${image.thumbnail_src}`}
                        alt={dictionary.image_texts[image.src]}
                        tabIndex="0"
                        onClick={() => openPhotoSwipe(index)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                openPhotoSwipe(index);
                            }
                        }}
                    />
                ))}
               
                {/* Photoswipe root element */}
                <div ref={pswpElement} className="pswp" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="pswp__bg"></div>
                    <div className="pswp__scroll-wrap">
                        <div className="pswp__container">
                            <div className="pswp__item"></div>
                            <div className="pswp__item"></div>
                            <div className="pswp__item"></div>
                        </div>
                        <div className="pswp__ui pswp__ui--hidden">
                            <div className="pswp__top-bar">
                                <div className="pswp__counter"></div>
                                <button className="pswp__button pswp__button--close" title="Close (Esc)"></button>
                                <button className="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                                <button className="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                                <div className="pswp__preloader">
                                    <div className="pswp__preloader__icn">
                                        <div className="pswp__preloader__cut">
                                            <div className="pswp__preloader__donut"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
                            <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
                            <div className="pswp__caption">
                                <div className="pswp__caption__center"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </>
    );
}

export default ImagePage;